module.exports = __webpack_public_path__ + "img/tuyau_apparent.243a828.svg";